import React, { Component, PropTypes } from 'react';

class PagesModifyRes extends Component {
    render() {
        return (
            <div>
                Content of PagesModifyRes
                <hr />
                {this.props.children}
            </div>
        );
    }
}

PagesModifyRes.propTypes = {
    children: PropTypes.element
};

export default PagesModifyRes;



// WEBPACK FOOTER //
// ./src/components/pages/pages/PagesModifyRes.js